import { render } from "./BindingStep11View.vue?vue&type=template&id=5cf274fa&scoped=true"
import script from "./BindingStep11View.vue?vue&type=script&lang=js"
export * from "./BindingStep11View.vue?vue&type=script&lang=js"

import "./assets/index.css?vue&type=style&index=0&id=5cf274fa&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf274fa"]])

export default __exports__